"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var FetchError = /** @class */function (_super) {
  __extends(FetchError, _super);
  function FetchError(message, url, status, statusText) {
    if (status === void 0) {
      status = 0;
    }
    if (statusText === void 0) {
      statusText = '';
    }
    var _this = _super.call(this, message) || this;
    _this.url = url;
    _this.status = status;
    _this.statusText = statusText;
    return _this;
  }
  return FetchError;
}(Error);
exports.default = FetchError;